import React from 'react';

export type CardHeaderPaddingVariant = 'pad-xl' | 'pad-lg' | 'pad-md' | 'pad-sm' | 'pad-xs' | 'pad-xxs';

interface CardHeaderProps {
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    title: React.ReactNode;
    subtitle?: string;
    actions?: React.ReactNode;
    className?: string;
    /** Applies card padding token; default is no padding. */
    paddingVariant?: CardHeaderPaddingVariant;
}

const CardHeader: React.FC<CardHeaderProps> = ({
    as: Tag = 'h2',
    title,
    subtitle,
    actions,
    className,
    paddingVariant,
}) => {
    const rootClassName = ['card-header', paddingVariant ? `card-header-${paddingVariant}` : undefined, className]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={rootClassName}>
            <div className="header-content">
                <Tag>{title}</Tag>
                {subtitle && <span className="header-subtitle">{subtitle}</span>}
            </div>
            {actions && <div className="header-actions">{actions}</div>}
        </div>
    );
};

export default CardHeader;
